define(['jquery', 'text!../templates/facebook-share.html'],
    ($, templateStr) => {

        let fbClient = null;

        const fn = (FacebookService, TranslateService) => ({
            restrict: 'AE',
            template: templateStr,
            link: scope => {

                function translate(shareData) {
                    Object.keys(shareData)
                        .filter(key => shareData[key].startsWith('facebook.share-dialog'))
                        .forEach(key => TranslateService.translate({
                            object: shareData,
                            propName: key,
                            displayKey: shareData[key],
                            scope
                        }));

                    return shareData;
                }

                const shareData = translate(FacebookService.getShareDialogData());

                if (!fbClient) {
                    FacebookService.getClient().then(client => {
                        fbClient = client;  // preload to make popup a direct user action instead of a promise
                    });
                }

                scope.share = () => {
                    if (fbClient) {
                        const share = Object.assign({method: 'share'}, shareData);
                        fbClient.ui(share);
                    }
                };

                scope.shareData = shareData;
            }
        });
        fn.$inject = ['FacebookService', 'TranslateService'];

        return fn;
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/facebook/directives/FacebookSharing.js